import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { ActionDotsBlack } from '../../icons';
import { useServiceCarStore } from '../../store/serviceCarStore';
import { checkBookingEnabled, checkDriverManage } from '../../utils/helper';
import BookAServiceInfoModal from '../elements/bookAServiceInfoModal';

const CarMobileViewTitle = ({ selectedCar, handleAssignClick }) => {
  const navigate = useNavigate();
  const { setCarInfo } = useServiceCarStore();
  const [openPopover, setOpenPopover] = useState(false);

  const { actions } = selectedCar || {};

  const isDriverManage = actions && checkDriverManage(actions);

  const isBookingEnabled = actions && checkBookingEnabled(actions);

  return (
    <div
      className={`lg:hidden ${
        selectedCar && (isDriverManage || isBookingEnabled) ? '' : 'invisible'
      }`}
    >
      <Popover
        open={openPopover}
        onOpenChange={(open) => {
          setOpenPopover(open);
        }}
      >
        <PopoverTrigger>
          <ActionDotsBlack
            className={
              openPopover
                ? 'bg-black stroke-white rounded-full'
                : 'stroke-black cursor-pointer'
            }
          />
        </PopoverTrigger>
        <PopoverContent>
          <ul className="flex flex-col gap-y-2.5 p-2.5">
            {isDriverManage && (
              <li>
                <button
                  type="button"
                  className="text-body"
                  onClick={handleAssignClick}
                >
                  Assign Driver
                </button>
              </li>
            )}
            {isBookingEnabled ? (
              <li>
                <button
                  type="button"
                  className="text-body"
                  onClick={() => {
                    navigate('/service-booking');
                    setCarInfo(selectedCar);
                  }}
                >
                  Ραντεβού Service
                </button>
              </li>
            ) : (
              <BookAServiceInfoModal showAsBtn={false} />
            )}
          </ul>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default CarMobileViewTitle;
